import React, { useEffect, useState } from "react";
import { get } from "lodash";

import Preloader from "~/components/Preloader";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import {
  IndicatorGroup,
  useGetIndicatorGroupByIdLazyQuery,
} from "~/schemas/generated/graphql";

import CatalogsOfReports from "./ui/CatalogsOfReports";
import TemplatesOfReports from "./ui/TemplatesOfReports";

import s from "./EditorReports.less";

const EditorReports = () => {
  const [currentReportGroup, setCurrentReportGroup] =
    useState<IndicatorGroup>(null);
  const [getGroup, getGroupState] = useGetIndicatorGroupByIdLazyQuery({
    fetchPolicy: "no-cache",
  });

  const setParams = useURLParamsSetter();
  const { name, groupId } = useURLParamsGetter<{
    name: string;
    groupId: string;
  }>();

  const onHandleClickByRows = (item: IndicatorGroup) => {
    if (item) {
      setParams({ name: item.nameRu, groupId: item.id });
      setCurrentReportGroup(item);
    } else {
      setCurrentReportGroup(null);
    }
  };

  useEffect(() => {
    if (groupId) {
      getGroup({
        variables: { GroupId: groupId },
      });
    }
  }, [groupId]);

  useEffect(() => {
    if (!getGroupState.loading && getGroupState.data)
      setCurrentReportGroup(
        get(getGroupState.data, "IndicatorGroupReportGetter.getIndicatorGroup"),
      );
  }, [getGroupState]);

  return (
    <div className={s.wrapper}>
      {getGroupState.loading ? (
        <Preloader />
      ) : currentReportGroup ? (
        <TemplatesOfReports
          groupId={currentReportGroup.id}
          groupStatus={currentReportGroup.status}
          onHandleClickByRows={onHandleClickByRows}
        />
      ) : (
        <CatalogsOfReports onHandleClickByRows={onHandleClickByRows} />
      )}
    </div>
  );
};

export default EditorReports;
